// src/components/products/RecommendationInfo.tsx

import React from 'react';
import styled from 'styled-components';
import type { RecommendProduct } from '../../services/api';

const RecommendBlock = styled.div`
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(123, 104, 238, 0.08), rgba(135, 206, 235, 0.08));
  border-radius: 20px;
  border: 1px solid rgba(123, 104, 238, 0.25);
  box-shadow: 0 4px 12px rgba(123, 104, 238, 0.1);
  box-sizing: border-box;

  [data-theme="dark"] & {
    background: linear-gradient(135deg, rgba(196, 181, 253, 0.12), rgba(160, 216, 240, 0.12));
    border: 1px solid rgba(196, 181, 253, 0.25);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 375px) {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 16px;
  }
`;

const RecommendHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

const RecommendIcon = styled.div`
  font-size: 22px;
  flex-shrink: 0;
  line-height: 1;
  filter: drop-shadow(0 2px 4px rgba(123, 104, 238, 0.3));

  @media (max-width: 375px) {
    font-size: 20px;
  }
`;

const RecommendTitle = styled.h3`
  font-size: 17px;
  font-weight: 700;
  color: #7B68EE;
  margin: 0;
  letter-spacing: -0.3px;

  [data-theme="dark"] & {
    color: #C4B5FD;
  }

  @media (max-width: 375px) {
    font-size: 16px;
  }
`;

const RecommendText = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
  margin: 0;
  line-height: 1.6;
  white-space: pre-wrap;

  [data-theme="dark"] & {
    color: rgba(255, 255, 255, 0.85);
  }

  @media (max-width: 375px) {
    font-size: 13px;
    line-height: 1.5;
  }
`;

interface RecommendationInfoProps {
  products: RecommendProduct[];
}

export const RecommendationInfo: React.FC<RecommendationInfoProps> = ({ products }) => {
  const recommendText = products.find(p =>
    p.recommend_text &&
    typeof p.recommend_text === 'string' &&
    p.recommend_text.trim().length > 0
  )?.recommend_text;

  if (!recommendText) {
    return null;
  }

  return (
    <RecommendBlock>
      <RecommendHeader>
        <RecommendIcon>✨</RecommendIcon>
        <RecommendTitle>Рекомендуем для вашего этапа</RecommendTitle>
      </RecommendHeader>
      <RecommendText>{recommendText}</RecommendText>
    </RecommendBlock>
  );
};
